import React, { useEffect, useState } from "react";
import Loader from "../Loader/Loader";
import { DetailBoxWrapper } from "./DetailStyled";
import { TextField, Box } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { useDispatch } from 'react-redux';
import { saveQuoteDetails } from "../../../Actions/QuoteAction";
import { AllProductsEnum, CalculatedProducts, UserRole, BankOfHoursComponentsEnum } from "../../QuoteRequest/Content";
import Notification from "../Notification/Notification";
import { Severity } from "../Notification/NotificationContent";

let quoteDetails = {
    quoteId: "",
    oppurtunityId: "",
    oppurtunity: "",
    oppurtunityName: "",
    quoteName: "",
    accountName: "",
    accountId: "",
    oppurtunityType: "",
    member: "",
    referrerName: "",
    commission: 0,
    percentagePaid: 0,
    discount: 0,
    currencyId: 0,
    existingPartneredClientInfo: "",
    noOfLivesSavedByPartner: "",
    totalPotentialHeadCountOutside: "",
    formalRFPNotes: "",
    competitorsBidders: "",
    pastQuotes: "",
    currentUtilizationWithOtherVendors: "",
    deadline: null,
    noOfRAMs: "",
    locationRAMs: "",
    samPriceRecommendAssumption: "",
    productId: 0,
    productVariationId: 0,
    componentIds: "",
    sessions: 0,
    utilization: 0,
    pricingStructureId: 0,
    hours: 0,
    rfpFileName: null,
    additionalNotes: "",
    currentRateEffectiveOn: "",
    pastThreeYrRateHeadCount: "",
    estimatedNoOfAMHrPerYear: "",
    annualUtilizationThreeYrs: "",
    quoteStatusId: 0,
    accountManagerName: "",
    amHours: 0,
    userId: 0,
    seatCount: 0,
    companyId: 0,
    isDiscount: false,
    ucmsId: ''
};

const Detail = ({ quote, quotedRateReqCurrency, quotedRateUSD, loggedUser }) => {
    const dispatch = useDispatch();
    const [annualRevenueReqCurrency, setAnnualRevenueReqCurrency] =
        useState(null);
    const [annualRevenueUSD, setAnnualRevenueUSD] = useState(null);
    const [totalAmHours, setTotalAmHours] = useState(quote?.quoteDetails?.amHours);
    const [errors, setErrors] = useState({});
    const [isAmHourEdit, setIsAmHourEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [quoteDetailValues, setQuoteDetailValues] = useState({ ...quoteDetails });
    const [notificationMsg, setNotificationMsg] = useState("");
    const [showNotification, setShowNotification] = useState(false);
    const [notificationSeverity, setNotificationSeverity] = useState("");
    const [allInPrice, setAllInPrice] = useState(undefined);
    const closeNotificationPopup = () => {
        setShowNotification(false);
    };

    const checkBOHCompForHour = () => {
        return !quote?.components.some(comp =>
            comp?.componentName?.includes(BankOfHoursComponentsEnum.ITDEVELOPMENT) || comp?.componentName?.includes(BankOfHoursComponentsEnum.CONSULTING)
        );
    };
    useEffect(() => {
        let alInPrice = {};
        setQuoteDetailValues(quote?.quoteDetails);
        if (quote?.allInPrice.length) {
            alInPrice = { ...quote?.allInPrice[quote?.allInPrice.length - 1] };
            setAllInPrice(alInPrice);
            let countryAmHours = [];

            quote.allInPrice.map((item) => {
                if (countryAmHours.length > 0) {
                    const index = countryAmHours.find(
                        (x) => x.countryId === item.countryId
                    );
                    if (!index) {
                        countryAmHours.push({
                            countryId: item.countryId,
                            amHours: item.amHoursIncluded,
                        });
                    }
                } else {
                    countryAmHours.push({
                        countryId: item.countryId,
                        amHours: item.amHoursIncluded,
                    });
                }
            });

            let sumAmHours = 0;

            countryAmHours.map((item) => {
                sumAmHours += item.amHours;
            });

            sumAmHours = Math.round(sumAmHours);

            if (Object.values(CalculatedProducts).includes(quote?.quoteDetails?.productId) && (quote?.quoteDetails?.productId !== AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS
                && quote?.quoteDetails?.productId !== AllProductsEnum.PATHWAYS
                && quote?.quoteDetails?.productId !== AllProductsEnum.GLOBALWELLBEINGQUESTIONNAIRE
                && quote?.quoteDetails?.productId !== AllProductsEnum.NEWPARENTRETURNTOWORK)) {
                setTotalAmHours(sumAmHours);
            }
            setAnnualRevenueReqCurrency(
                Number(
                    alInPrice?.revenueStage5TotalReqCurrency?.toFixed(2)
                ).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 })
            );
            setAnnualRevenueUSD(
                Number(alInPrice?.revenueStage5TotalUSD?.toFixed(2)).toLocaleString(
                    "en",
                    { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }
                )
            );
        }
    }, []);

    const onTextChange = (event) => {
        const { name, value } = event.target;
        let amHourError = "";

        if (name === "txtAmHours") {
            amHourError = "Please enter a valid number!";
            if (!isNaN(value)) {
                let newvalue = value.trim() === "" ? "" : parseInt(value?.trim());
                amHourError = "";
                setTotalAmHours(newvalue);

                setQuoteDetailValues((prevValues) => ({
                    ...prevValues,
                    amHours: newvalue,
                    userId: loggedUser?.user?.id,
                }));
            }
        }
    }

    function validateInput(formValues) {
        let errors = {};

        if (!formValues?.amHours?.toString()?.trim()) {
            errors.amHoursError = "This field is required";
        }
        return errors;
    }

    const handleEditAmHours = () => {
        setIsAmHourEdit(true);

    }

    const handleUpdateAmHours = () => {
        setIsLoading(true);
        const validationErrors = validateInput(quoteDetailValues)
        if ((Object.keys(validationErrors).length <= 0)) {
            dispatch(saveQuoteDetails(quoteDetailValues))
                .then(data => {
                    console.log('save am Hour', data);
                    setNotificationMsg("AM Hours updated successfully");
                    setNotificationSeverity(Severity.SUCCESS);
                    setShowNotification(true);
                    setIsAmHourEdit(false);
                    setIsLoading(false);
                })
                .catch(e => {
                    console.log('error saving am hours', e);
                    setIsAmHourEdit(false);
                    setIsLoading(false);
                });
        } else {
            setIsLoading(false);
        }
    }

    function getComponents() {
        return (
            <>
                {quote?.components?.map((component) => {
                    return (
                        <ul key={component.id} className="ul-content">
                            <li className="componentList">{component.componentName}</li>
                        </ul>
                    )
                })}
            </>
        );
    }

    return (
        <DetailBoxWrapper>
            <div>
                <div className="d-flex"  >
                    <div className="content">
                        <h5>Product</h5>
                        <span>{quote?.quoteDetails?.productName}</span>
                    </div>
                    <div className="content">
                        <h5>Product Variation</h5>
                        <span>{quote?.quoteDetails?.productVariationName}</span>
                    </div>
                    {quote?.quoteDetails.productId != AllProductsEnum.EVOLUTION && <div className="content">
                        <h5>Session Model</h5>
                        <span>{quote?.quoteDetails?.sessions}</span>
                    </div>}
                    <div className="content">
                        <h5>Utilization</h5>
                        <span>{quote?.quoteDetails?.isUtilizationUpdated ? (quote?.quoteDetails?.blendedUtilization?.toLocaleString("en", {
                            useGrouping: true,
                            roundingMode: "trunc",
                            maximumFractionDigits: 2,
                        })) : (quote?.quoteDetails?.utilization?.toLocaleString("en", {
                            useGrouping: true,
                            roundingMode: "trunc",
                            maximumFractionDigits: 2,
                        }))}%</span>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="content">
                        <h5>AM Hours</h5>

                        {
                            (isAmHourEdit ?
                                <div>
                                    <TextField
                                        className="smallTxtField"
                                        value={totalAmHours}
                                        size="small"
                                        onChange={(e) => onTextChange(e)}
                                        name="txtAmHours"
                                    />
                                    <Box>
                                        {errors.amHours && (
                                            <span className="error">
                                                {errors.amHours}
                                            </span>
                                        )}
                                    </Box>
                                </div>
                                :
                                <span>{totalAmHours}</span>

                            )}
                        {((loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM || 
                            loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER || 
                            loggedUser?.userRole[0]?.id === UserRole.PRICINGVP) && !Object.values(CalculatedProducts).includes(quote?.quoteDetails?.productId))
                            && (!isAmHourEdit ?
                                <IconButton className="icon" aria-label="edit"
                                    onClick={handleEditAmHours}>
                                    <Tooltip id="viewbutton-report" title="Edit">
                                        <DriveFileRenameOutlineOutlinedIcon />
                                    </Tooltip>
                                </IconButton>
                                :
                                <IconButton className="icon" aria-label="save"
                                    onClick={handleUpdateAmHours}>
                                    <Tooltip id="viewbutton-report" title="Save">
                                        <SaveOutlinedIcon />
                                    </Tooltip>
                                </IconButton>
                            )}

                    </div>
                    <div className="content">
                        <h5>
                            Annual Revenue<b> (USD)</b>
                        </h5>
                        <span>{annualRevenueUSD}</span>
                    </div>
                    <div className="content">
                        <h5>
                            Quoted Rate<b> (USD)</b>
                        </h5>
                        <span>{quotedRateUSD}</span>
                    </div>
                    <div className="content">
                        <h5>Broker Name</h5>
                        <span>{quote?.opportunityDetails?.oppurtunityReferrerName}</span>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="content">
                        <h5>Pricing Strcture</h5>
                        <span>{quote?.quoteDetails?.pricingStructureName}</span>
                    </div>
                    <div className="content">
                        <h5>
                            Annual Revenue<b> ({quote?.quoteDetails?.currencyCode})</b>
                        </h5>
                        <span>{annualRevenueReqCurrency}</span>
                    </div>
                    <div className="content">
                        <h5>
                            Quoted Rate<b> ({quote?.quoteDetails?.currencyCode})</b>
                        </h5>
                        <span>{quotedRateReqCurrency}</span>
                    </div>
                    <div className="content">
                        <h5>Broker Commission</h5>
                        <span>
                            {quote?.opportunityDetails?.commissionPercent === 0 ||
                                quote?.opportunityDetails?.commissionPercent === ""
                                ? 0
                                : quote?.opportunityDetails?.commissionPercent}
                            %
                        </span>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="content">
                        <h5>Number Of Years</h5>
                        <span>{quote?.quoteDetails?.numberOfYears}</span>
                    </div>
                    <div className="content">
                        <h5>TCV (CAD)</h5>
                        <span>{allInPrice?.tcvcad?.toLocaleString("en", {
                            useGrouping: true,
                            roundingMode: "trunc",
                            maximumFractionDigits: 2,
                        })}</span>
                    </div>                    
                </div>
                {((quote?.quoteDetails?.productId === AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS
                    || quote?.quoteDetails?.productId === AllProductsEnum.PATHWAYS) && checkBOHCompForHour()) && (
                        <div className="d-flex">
                            <div className="content">
                                <h5>Hours</h5>
                                <span>
                                    {quote?.quoteDetails?.hours === 0 ||
                                        quote?.quoteDetails?.hours === ""
                                        ? 0
                                        : quote?.quoteDetails?.hours}

                                </span>
                            </div>
                        </div>
                    )}
                {(quote?.quoteDetails?.productId === AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS) && (
                    <div className="d-flex" >
                        <div className="content">
                            <h5>Components</h5>
                        </div>
                        <div className="d-flex" style={{ borderBottom: "0px" }}>
                            {getComponents()}
                        </div>
                    </div>
                )}

            </div>
            {((quotedRateReqCurrency === "" && quotedRateUSD === "") || isLoading) && <Loader open={(quotedRateReqCurrency === "" && quotedRateUSD === "") || isLoading} />}
            {showNotification && (
                <Notification
                    open={showNotification}
                    onClose={closeNotificationPopup}
                    message={notificationMsg}
                    severity={notificationSeverity}
                />
            )}
        </DetailBoxWrapper>

    );
};

export default Detail;
